import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';

@Component({
  selector: 'app-alerta-flutuante',
  templateUrl: './alerta-flutuante.component.html',
  styleUrls: ['./alerta-flutuante.component.scss']
})
export class AlertaFlutuanteComponent implements OnChanges {
  @Input() show = false;
  @Input() tipoAlerta: string = null;
  @Input() texto: string = null;
  @Output() limparValidacao = new EventEmitter();

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['show'] && changes['show'].currentValue === true) {
      this.autoHide();
    }
  }

  private autoHide() {
    setTimeout(() => {
      this.show = false;
      this.limparValidacao.emit();
    }, 20000);
  }
}
